import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCKingSvanson extends NPC {
    constructor() {
        super(definitions.NPC_ID.KING_SVANSON);

        this.collisionRadius = 34;
        this.collisionOffsetX = -9;
        this.collisionOffsetY = -34;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_king_svanson_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.LARGE, 1, new PIXI.Point(-6, -6));
        this.animateIdle(1);
    }
}